// extracted by mini-css-extract-plugin
export default {"promo-input__apply-button":"promo-input__apply-button--0HcOX","promoInputApplyButton":"promo-input__apply-button--0HcOX"};